import { useMutation } from "@apollo/client";
import { faClose } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Form, Input, message, Modal, Select, TimePicker } from "antd"
import { UpsertMobileResponseETAMutation } from "../../util/mutation/mobileServices.mutation";
import { useEffect, useState } from "react";
import Spinner from "@src/components/spinner";
import TextArea from "antd/es/input/TextArea";


export const NewETAModal = ({visible, onClose, newETAResponseId, refetch}) => {

    const [upsertMobileResponseETA, {loading: upsertMobileResponseETALoading}] = useMutation(UpsertMobileResponseETAMutation);
    
    const [eta, setEta] = useState(null);
    const [notes, setNotes] = useState("");
    useEffect(()=>{setEta(null)}, []);
    
    const handelSubmit = async() => {
        // Handle the submit logic here
        if(eta){
            await upsertMobileResponseETA({
                variables: {
                    responseId: newETAResponseId,
                    eta: eta,
                    notes: notes
                }
            });
            message.success("ETA was updated successfully");
            setEta(null);
            refetch();
            onClose();

        }else{
            message.warning("ETA required");
        }
    };

    return (

        <Modal
            open={visible}
            footer={
                 <div 
                    className="drawer-footer"
                    style={{display:'flex', justifyContent:'flex-end', gap:'10px'}}
                >
                    <button onClick={onClose} className={upsertMobileResponseETALoading? "drawer-outlined-btn disabled-btn" : "drawer-outlined-btn"}>Cancel</button>
                    <button className={upsertMobileResponseETALoading || !eta? "drawer-filled-btn disabled-btn" : "drawer-filled-btn"} onClick={handelSubmit}>
                        Save {upsertMobileResponseETALoading? <Spinner /> : null}
                    </button>
                </div>
            }
            closable={false}
            width={'500px'}
            style={{top:2}}
        >
        {/* Header */}

            <div className='modal-header-title' style={{padding:'16px 40px'}}>
                <span style={{letterSpacing:'0.2px'}}> 
                    Update ETA
                </span>
                <span  onClick={async()=>{onClose()}}><FontAwesomeIcon className='close' icon={faClose}/></span>
            </div>
            
            <div  style={{opacity:1, padding:'20px', margin:'0 40px'}}>
                <label>Time</label>
                <Input
                    placeholder="Enter new ETA"
                    type="time" 
                    className="generic-input-control"
                    // style={{height:'20px' }}
                    onChange={(e)=>setEta(e.target.value)}
                    value={
                        eta
                    }
                /> 
                <br/>
                <br/>

                <label>Notes</label>

                <TextArea onChange={(e)=>setNotes(e.target.value)} className="generic-input-control" />
                
            </div>

        </Modal>


    );

};
